'use strict';
eventProfitLossController.$inject = ['$scope', '$rootScope', '$q', '$interval', 'reportHelper', 'eventService', 'siteService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('eventProfitLossController', eventProfitLossController);

function eventProfitLossController($scope, $rootScope, $q, $interval, reportHelper, eventService, siteService, BUSY_MESSAGE) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	if ($rootScope.mode && $rootScope.mode === 'sa') {
		$scope.vm.module = 'sa';
	}

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.loadingPromise = $q.all([$scope.vm.loadSites($scope.vm), $scope.vm.loadSponsors($scope.vm), $scope.vm.loadEvents($scope.vm)]);

	function getViewModel() {
		var model = {
			module: 'fund',
			message: BUSY_MESSAGE.Loading,
			report: {
				reportType: 'Detail',
				active: true,
				event: { Id: 0, EventCode: 'ALL', EventName: 'All Active Events' },
				site: { Id: 0, SiteName: 'ALL' },
				sponsor: 'ALL',
				allDates: true,
				fromDT: null,
				toDT: null,
			},

			sites: [],
			sponsors: [],
			events: [],
			backupEvents: [],

			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			let isValid = true;

			// Nothing to validate at this time.

			return isValid;
		}

		function openReport(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			model.validationErrors = [];
			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingReport;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				ReportType: model.report.reportType,
				Active: model.report.active,
				EventId: model.report.event.Id,
				EventName: model.report.event.EventName,
				SiteId: model.report.site.Id,
				SiteName: model.report.site.SiteName,
				Sponsor: model.report.sponsor,
				FromDT: moment(model.report.fromDT).toDate(),
				ToDT: moment(model.report.toDT).toDate(),
			};

			reportHelper.getReport($scope, '/api/fundreports/eventprofitlossreport', report, 'EventProfitLossReport.pdf');
		}

		function exportExcel(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			model.validationErrors = [];
			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingExcelFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				ReportType: model.report.reportType,
				Active: model.report.active,
				EventId: model.report.event.Id,
				EventName: model.report.event.EventName,
				SiteId: model.report.site.Id,
				SiteName: model.report.site.SiteName,
				Sponsor: model.report.sponsor,
				FromDT: moment(model.report.fromDT).toDate(),
				ToDT: moment(model.report.toDT).toDate(),
			};

			reportHelper.getExcel($scope, '/api/fundreports/eventprofitlossexcel', report, 'EventProfitAndLoss.xlsx');
		}

		function exportReportToCSV(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			model.validationErrors = [];
			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.message = BUSY_MESSAGE.GeneratingFile;
			$scope.loadingPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				ReportType: model.report.reportType,
				Active: model.report.active,
				EventId: model.report.event.Id,
				EventName: model.report.event.EventName,
				SiteId: model.report.site.Id,
				SiteName: model.report.site.SiteName,
				Sponsor: model.report.sponsor,
				FromDT: moment(model.report.fromDT).toDate(),
				ToDT: moment(model.report.toDT).toDate(),
			};

			reportHelper.getTextFile($scope, '/api/fundreports/eventprofitlossreportcsv', report, 'EventProfitLossReport.csv');
		}

		function loadSites(model) {
			return siteService.getSites().then(_.partial(finishLoadingSites, model));

			function finishLoadingSites(model, response) {
				model.sites = response.data.sites;
				// if there is only one site available then go ahead and select it for the user.
				if (model.sites.length === 1) {
					model.report.site.Id = model.sites[0].Id;
				} else {
					// if there is more than one site available then add an ALL option to the list.
					model.sites.unshift({ Id: 0, SiteName: 'ALL' });
				}
				return angular.noop;
			}
		}

		function loadSponsors(model) {
			return eventService.getSponsors().then(_.partial(finishLoadingSponsors, model));

			function finishLoadingSponsors(model, response) {
				model.sponsors = response.data.sponsors;
				model.sponsors.unshift('ALL');
				return angular.noop;
			}
		}

		function loadEvents(model) {
			return eventService.getEvents().then(_.partial(finishLoadingEvents, model));

			function finishLoadingEvents(model, response) {
				model.events = response.data.events;

				model.backupEvents = angular.copy(model.events);
				updateEventList(model);
				return angular.noop;
			}
		}

		function updateEventList(model) {
			model.events = angular.copy(model.backupEvents);
			let eventName = 'All Events';

			if (model.report.site.Id !== 0) {
				model.events = _.filter(model.events, function (event) {
					return event.SiteId === model.report.site.Id;
				});
			}

			if (model.report.sponsor !== 'ALL') {
				model.events = _.filter(model.events, function (event) {
					return event.Sponsor === model.report.sponsor;
				});
			}

			if (model.report.active !== null) {
				model.events = _.filter(model.events, function (event) {
					return event.Active === model.report.active;
				});
				eventName = model.report.active ? 'All Active Events' : 'All Inactive Events';
			}

			if (model.report.event.Id !== 0) {
				let found = _.find(model.events, function (event) {
					return event.Id === model.report.event.Id;
				});
				if (!found) model.report.event.Id = 0;
			}

			model.events.unshift({ Id: 0, EventCode: 'ALL', EventName: eventName });
		}

		function updateDates(model) {
			if (model.report.allDates) {
				model.report.fromDT = null;
				model.report.toDT = null;
			}
		}

		return angular.extend(model, {
			loadSites: _.partial(loadSites, model),
			loadSponsors: _.partial(loadSponsors, model),
			loadEvents: _.partial(loadEvents, model),
			updateEventList: _.partial(updateEventList, model),
			updateDates: _.partial(updateDates, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
			exportReportToCSV: _.partial(exportReportToCSV, model),
		});
	}
}
